import '@acb_devel/design-system/styles';

import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';

export function BaseLayout({ children }: { children: React.ReactNode }) {
  return <div>{children}</div>;
}
